import { ref } from 'vue'

export function useCoolDown(delay: number = 1500) {
  const currentCoolDown = ref(0)
  const coolingDown = ref(false)
  const callBackArgs = ref<Record<string, any>>({})

  function runCoolDown(callback: (args: any) => Promise<void>, args: Record<string, any>) {
    currentCoolDown.value = delay
    callBackArgs.value = args

    if (coolingDown.value) return

    coolingDown.value = true
    coolDown(currentCoolDown.value, callback)
  }

  function coolDown(time: number, callback: (attrs: any) => Promise<void>) {
    if (time < 0) {
      callback(callBackArgs.value)
      currentCoolDown.value = 0
      coolingDown.value = false
      return
    }

    coolingDown.value = true
    setTimeout(() => {
      currentCoolDown.value -= 10
      coolDown(currentCoolDown.value, callback)
    }, 10)
  }

  return {
    runCoolDown
  }
}
